import { hotRanking } from "@/mocks/homeData";
import SectionHead from "./SectionHead";

export default function HotRanking() {
  return (
    <section id="hot" className="scroll-mt-20 border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <SectionHead
          kicker="全网红热排行"
          title="吃瓜指数 Top 8"
          desc="按当日热度与搜索增量实时排序的档案条目。榜单反映讨论规模，不代表事实结论——每个标题背后都有一条完整时间线在「档案」里等着你。"
          action="查看完整榜单"
        />

        <ol className="mt-8 grid gap-3 md:mt-10 md:gap-4 lg:grid-cols-2">
          {hotRanking.map((item) => {
            const isTop = item.rank === 1;
            return (
              <li key={item.rank}>
                <a
                  href="#dangan"
                  className={`group flex items-center gap-4 rounded-lg border p-4 transition-colors md:gap-5 md:p-5 ${
                    isTop
                      ? "border-primary-300 bg-primary-600/5"
                      : "border-background-200 bg-background-50 hover:border-background-300"
                  }`}
                >
                  <span
                    className={`flex w-10 shrink-0 items-center justify-center font-display text-2xl font-black md:text-3xl ${
                      isTop ? "text-primary-600" : "text-background-400 group-hover:text-accent-600"
                    }`}
                  >
                    {String(item.rank).padStart(2, "0")}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className={`line-clamp-1 font-heading text-sm font-bold leading-snug md:text-base ${isTop ? "text-primary-800" : "text-foreground-900"}`}>
                      {item.title}
                    </p>
                    <div className="mt-2 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                      <span className="inline-flex items-center gap-1">
                        <span className="flex h-4 w-4 items-center justify-center">
                          <i className="ri-database-2-line" />
                        </span>
                        相关档案 {item.count}
                      </span>
                      <span className="inline-flex items-center gap-1 font-medium text-accent-700">
                        <span className="flex h-4 w-4 items-center justify-center">
                          <i className="ri-arrow-up-line" />
                        </span>
                        今日 +{item.delta}
                      </span>
                    </div>
                  </div>
                  {isTop && (
                    <span className="hidden shrink-0 items-center gap-1 rounded-full bg-primary-600 px-2.5 py-1 text-[11px] font-black text-background-50 sm:inline-flex">
                      <span className="flex h-3 w-3 items-center justify-center">
                        <i className="ri-fire-fill text-xs" />
                      </span>
                      爆
                    </span>
                  )}
                </a>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}